import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import NumberInput from 'shared/components/NumberInput/NumberInput';
import DecimalInput from 'shared/components/DecimalInput/DecimalInput';
import SelectInput from './SelectInput/SelectInput';
import s from './NumberInputWithSelect.css';

class NumberInputWithSelect extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    className: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    unitsSwitchOptions: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
      }),
    ),
    unitsSwitchValue: PropTypes.shape(),
    onChange: PropTypes.func,
    onUnitsChange: PropTypes.func,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    error: PropTypes.string,
    errorClassName: PropTypes.string,
    required: PropTypes.bool,
    decimal: PropTypes.bool,
    disabled: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
    Icon: PropTypes.func,
    titleKey: PropTypes.string,
    theme: PropTypes.string,
    type: PropTypes.string,
  };
  static defaultProps = {
    title: null,
    className: '',
    errorClassName: '',
    placeholder: '',
    unitsSwitchOptions: [],
    onChange: () => {},
    onUnitsChange: () => {},
    value: null,
    unitsSwitchValue: null,
    error: null,
    required: false,
    decimal: false,
    disabled: false,
    Icon: null,
    titleKey: 'title',
    theme: '',
    type: 'text',
  };

  handleSelectChange = (name, optionInfo) => {
    const { val, ...option } = optionInfo;
    this.props.onUnitsChange(option);
  };

  render() {
    const {
      title,
      placeholder,
      unitsSwitchValue,
      className,
      error,
      errorClassName,
      onChange,
      required,
      decimal,
      disabled,
      Icon,
      titleKey,
      theme, // TODO: Change to context
      type,
    } = this.props;
    const value = this.props.value || '';
    const unitsSwitchOptions = this.props.unitsSwitchOptions.filter(x => x);

    const inputProps = {
      value,
      className: s.input,
      placeholder,
      onChange,
      disabled,
      type,
    };

    return (
      <div
        className={cx(s.root, className, {
          [s[`theme-${theme}`]]: theme && s[`theme-${theme}`],
        })}
      >
        {title &&
          <div className={cx(s.title, { [s.required]: required })}>
            {title}
          </div>}

        <div
          className={cx(s.inline, {
            [s.hasIcon]: !!Icon,
          })}
        >
          {!!Icon &&
            <div className={s.icon}>
              <Icon />
            </div>}
          {decimal ? <DecimalInput {...inputProps} /> : <NumberInput inputMode="numeric" {...inputProps} />}
        </div>
        {unitsSwitchOptions &&
          unitsSwitchOptions.length > 0 &&
          <div className={`${s.switch}`}>
            <div className={s.switchDivider} />
            {unitsSwitchOptions.length === 1 &&
              <div className={s.singleOptionLabel}>
                {unitsSwitchOptions[0][titleKey] || unitsSwitchOptions[0].title || ''}
              </div>}
            {unitsSwitchOptions.length > 1 &&
              <SelectInput
                options={unitsSwitchOptions.map(option => ({ ...option, val: option.id }))}
                onChange={this.handleSelectChange}
                value={unitsSwitchValue && unitsSwitchValue.id}
                titleKey={titleKey}
              />}
          </div>}
        {error &&
          <p className={errorClassName}>
            {error}
          </p>}
      </div>
    );
  }
}

export default withStyles(s)(NumberInputWithSelect);



// WEBPACK FOOTER //
// ./src/shared/components/UI/NumberInputWithSelect/NumberInputWithSelect.js